import { render, staticRenderFns } from "./PendingApprovalServiceForm.vue?vue&type=template&id=d1a13a98&scoped=true&"
import script from "./PendingApprovalServiceForm.vue?vue&type=script&lang=js&"
export * from "./PendingApprovalServiceForm.vue?vue&type=script&lang=js&"
import style0 from "./PendingApprovalServiceForm.vue?vue&type=style&index=0&id=d1a13a98&prod&lang=scss&scoped=true&"
import style1 from "./PendingApprovalServiceForm.vue?vue&type=style&index=1&id=d1a13a98&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1a13a98",
  null
  
)

export default component.exports